<template>
  <v-container class="mb-3 cont-sec-transacciones no-gutters" fluid>
    <v-row class="no-gutters py-10 text-center cont-line">
      <v-col  cols="12" sm="10" class="text-left mx-auto mt-1 mb-4 pa-2">
        <h1 class="txt-primary"> {{itemsec.titulo}} </h1>
        <!-- <v-btn color="primary" small class="font-weight-bold" >Ver más</v-btn> -->
      </v-col>
      <v-col cols="12" class="text-center d-flex justify-center align-center" v-if="!cargoNoticias">
        <v-skeleton-loader v-for="nt in 3" :key="nt"
          class="mx-auto"
          width="230"
          type="card , list-item"
          light
        ></v-skeleton-loader>
      </v-col>
      <v-col cols="12" sm="10" class="cont-slider mx-auto" v-else>

        <VueSlickCarousel  v-bind="settings" class="text-justify">
          <v-card class="ma-2" max-width="220" color="white" elevation="5" v-for="(noti, idx) in noticias"
            :key="'noti-'+idx">
                <v-img class="white--text align-end" height="200px"
                :src="noti.imagen"
                >
                </v-img>
              <v-card-subtitle class="pb-0">
                {{noti.fecha}}
              </v-card-subtitle>
              <v-divider></v-divider>
              <v-card-text class="text--primary" height="400px" >
                <div class="lh-1-2 text-noticia">{{noti.titulo}}</div>
              </v-card-text>
              <v-card-actions class="d-flex justify-end">
                <v-btn color="primary" small text outlined class="font-weight-bold"
                @click="leerMas(noti.id_noticia, noti.titulo)"
                >
                  LEER MÁS
                </v-btn>
              </v-card-actions>
            </v-card>
            <template #prevArrow>
              <v-btn color="primary"
                fab
                dark
                small>
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </template>
            <template #nextArrow>
               <v-btn color="primary"
                fab
                dark
                small>
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </template>
        </VueSlickCarousel>

      </v-col>
    </v-row>
    </v-container>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import VueSlickCarousel from 'vue-slick-carousel'

export default {
  name: 'secNoticias',
  components: { VueSlickCarousel },
  data () {
    return {
      itemsec: {
        titulo: 'Noticias y novedades'
      },
      model: null,
      info: null,
      cargoNoticias: false,
      noticias: [],
      settings: {
        'dots': false,
        'infinite': true,
        'initialSlide': 0,
        'speed': 500,
        'slidesToShow': 4,
        'slidesToScroll': 2,
        'swipeToSlide': true,
        'arrows': true,
        'responsive': [
          {
            'breakpoint': 1024,
            'settings': {
              'slidesToShow': 3,
              'slidesToScroll': 3,
              'infinite': true
            }
          },
          {
            'breakpoint': 600,
            'settings': {
              'slidesToShow': 2,
              'slidesToScroll': 2
            }
          },
          {
            'breakpoint': 480,
            'settings': {
              'slidesToShow': 1,
              'slidesToScroll': 1
            }
          }
        ]
      }
    }
  },
  async created () {
    await axios
      .get('' + this.$store.state.rutaApi + 'noticia')
      .then(response => (this.noticias = response.data))
    this.cargoNoticias = true
    // console.log(this.noticias[0])
  },
  mounted () {
  },
  methods: {
    leerMas (val, name) {
      this.$store.dispatch('saveIdContenido', val)
      this.$router.push({ name: 'noticias', params: { idCont: val, catName: name } }).catch(() => {})
    }
  },
  computed: {
    ...mapGetters(['saveIdContenido'])
  }
}
</script>
<style lang="scss" scoped>
.cont-sec-transacciones{
  background: url('../assets/img/back-sec-noticias.png')no-repeat;
  background-attachment: fixed;
  background-position: left center;
  background-size: 40vw;
  padding: 0px;
  // @media screen and(max-width:600px) {
  // background-size: contain;
  // }
}
.cont-line{
background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 30%, rgba(255,255,255,0) 60%, rgba(255,255,255,1) 100%);
}
.card-item{
  padding: 10px;
  text-align: center;
  color: #2B5AC4;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.6)!important;

  h3{
    font-size: 1em;
  }
}
.card-item{
  background: #FFFFFF;
  padding: 10px;
  border-radius: 10px;
  width: 270px;
}
.cont-slider{
  padding: 0px 35px;
}
.text-noticia{
  font-size: 1em;
}
</style>
